import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Font,
} from "@react-pdf/renderer";

import tajawalFont from "../../assets/font/Tajawal-Regular.ttf";

Font.register({
  family: "Tajawal",
  fonts: [
    {
      src: tajawalFont,
    },
  ],
});

// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    backgroundColor: "#ffffff",
    padding: 20,
    fontSize: 10,
    fontFamily: "Tajawal",
    paddingBottom: 70,
  },
  pageArabic: {
    flexDirection: "column",
    backgroundColor: "#ffffff",
    padding: 20,
    fontSize: 10,
    fontFamily: "Tajawal",
    paddingBottom: 70,
  },
  arabicText: {
    fontFamily: "Tajawal",
    textAlign: "right",
    direction: "rtl",
  },
  englishText: {
    fontFamily: "Tajawal",
    textAlign: "left",
    direction: "ltr",
  },
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: 20,
    borderBottomWidth: 2,
    borderBottomColor: "#333333",
    paddingBottom: 15,
  },
  headerRTL: {
    display: "flex",
    flexDirection: "row-reverse",
    justifyContent: "space-between",
    alignItems: "flex-end",
    marginBottom: 20,
    borderBottomWidth: 2,
    borderBottomColor: "#333333",
    paddingBottom: 15,
  },
  companyInfo: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
  },
  companyName: {
    fontSize: 20,
    fontWeight: "bold",
    color: "#79329a",
    marginBottom: 5,
  },
  companyDetails: {
    fontSize: 8,
    color: "#666666",
  },
  companyDetailsRTL: {
    fontSize: 8,
    color: "#666666",
    textAlign: "right",
    direction: "rtl",
  },
  payslipTitle: {
    fontSize: 24,
    fontWeight: "bold",
    color: "#79329a",
    letterSpacing: 2,
  },
  infoSection: {
    flexDirection: "row",
    marginBottom: 20,
    gap: 30,
  },
  infoSectionRTL: {
    flexDirection: "row-reverse",
    marginBottom: 20,
    gap: 30,
  },
  infoBox: {
    flex: 1,
  },
  sectionHeader: {
    backgroundColor: "#79329abd",
    color: "#ffffff",
    padding: 5,
    fontSize: 9,
    fontWeight: "bold",
    marginBottom: 8,
    textAlign: "center",
  },
  infoRow: {
    flexDirection: "row",
    marginBottom: 3,
    fontSize: 9,
  },
  infoRowRTL: {
    flexDirection: "row-reverse",
    marginBottom: 3,
    fontSize: 9,
  },
  infoLabel: {
    fontWeight: "bold",
    marginRight: 5,
  },
  infoLabelRTL: {
    fontWeight: "bold",
    marginLeft: 5,
    textAlign: "right",
  },
  payslipInfoGrid: {
    flexDirection: "column",
    gap: 2,
  },
  gridRow: {
    flexDirection: "row",
    gap: 2,
  },
  gridRowRTL: {
    flexDirection: "row-reverse",
    gap: 2,
  },
  gridHeader: {
    flex: 1,
    backgroundColor: "#79329a8d",
    padding: 4,
    textAlign: "center",
    fontWeight: "bold",
    fontSize: 9,
  },
  gridValue: {
    flex: 1,
    backgroundColor: "#f3f4f6",
    padding: 4,
    textAlign: "center",
    fontSize: 9,
  },
  earningsSection: {
    marginBottom: 15,
  },
  sectionTitle: {
    backgroundColor: "#d1d5db",
    color: "#000000",
    padding: 6,
    fontSize: 10,
    marginBottom: 2,
  },
  table: {
    flexDirection: "column",
    borderWidth: 1,
    borderColor: "#d1d5db",
  },
  tableHeader: {
    flexDirection: "row",
    backgroundColor: "#e5e7eb",
    borderBottomWidth: 1,
    borderBottomColor: "#9ca3af",
  },
  tableHeaderRTL: {
    flexDirection: "row-reverse",
    backgroundColor: "#e5e7eb",
    borderBottomWidth: 1,
    borderBottomColor: "#9ca3af",
  },
  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#d1d5db",
  },
  tableRowRTL: {
    flexDirection: "row-reverse",
    borderBottomWidth: 1,
    borderBottomColor: "#d1d5db",
  },
  tableCell: {
    flex: 2,
    padding: 4,
    fontSize: 9,
    borderRightWidth: 1,
    borderRightColor: "#d1d5db",
  },
  tableCellCenter: {
    flex: 1,
    padding: 4,
    fontSize: 9,
    textAlign: "center",
    borderRightWidth: 1,
    borderRightColor: "#d1d5db",
  },
  tableCellRight: {
    flex: 1,
    padding: 4,
    fontSize: 9,
    textAlign: "right",
    borderRightWidth: 1,
    borderRightColor: "#d1d5db",
  },
  attendanceInfo: {
    flexDirection: "row",
    justifyContent: "space-around",
    margin: "8 0",
    fontSize: 9,
  },
  attendanceInfoRTL: {
    flexDirection: "row-reverse",
    justifyContent: "space-around",
    margin: "8 0",
    fontSize: 9,
  },
  totalRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    backgroundColor: "#d1d5db",
    padding: 6,
    fontWeight: "bold",
    fontSize: 10,
  },
  totalRowRTL: {
    flexDirection: "row-reverse",
    justifyContent: "space-between",
    backgroundColor: "#d1d5db",
    padding: 6,
    fontWeight: "bold",
    fontSize: 10,
  },
  netPayRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    backgroundColor: "#1f2937",
    color: "#ffffff",
    padding: 10,
    fontWeight: "bold",
    fontSize: 12,
    marginBottom: 15,
  },
  netPayRowRTL: {
    flexDirection: "row-reverse",
    justifyContent: "space-between",
    backgroundColor: "#1f2937",
    color: "#ffffff",
    padding: 10,
    fontWeight: "bold",
    fontSize: 12,
    marginBottom: 15,
  },
  footer: {
    fontSize: 8,
    textAlign: "center",
    color: "#6b7280",
    borderTopWidth: 1,
    borderTopColor: "#d1d5db",
    paddingTop: 8,
  },
  boldText: {
    fontWeight: "bold",
  },
});

const MonthAttendancePDFTemplate = ({
  language = "EN",
  companyData = {},
  employeeData = {},
  attendanceData = {},
  days = [],
  presentDays = 0,
  absentDays = 0,
  vacationDays = 0,
}) => {
  console.log("ATTENDANCE DATA IN TEMPLATE:", attendanceData);
  const isArabic = language === "AR";

  // Default data
  const defaultCompanyData = {
    name: isArabic ? "اسم الشركة" : "Company Name",
    address: isArabic
      ? "١٢٣٤ شارع المحكمة، لندن W1T 1JY، المملكة المتحدة"
      : "1234 Court Road, London W1T 1JY, UK",
    phone: "+44 00 0000 0000",
    email: "name@provider.com",
    ...companyData,
  };

  const defaultEmployeeData = {
    fullName: isArabic ? "أحمد محمد" : "John Doe",
    address: isArabic
      ? "١٢٣ أي شارع، لندن W1T 1JY، المملكة المتحدة"
      : "123 Any Court Road, London W1T 1JY, UK",
    phone: "+44 00 0000 0000",
    email: "john@provider.com",
    ...employeeData,
  };

  const defaultAttendanceData = {
    // printDate: "6/10/2019",
    // totalSalary: 2500.0,
    // paidSalary: 2500.0,
    // dueSalary: 0,
    ...attendanceData,
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "IQD",
    }).format(amount);
  };

  // Helper component for text with proper styling
  const StyledText = ({ children, style = {} }) => {
    const baseStyle = isArabic ? styles.arabicText : styles.englishText;
    return <Text style={{ ...baseStyle, ...style }}>{children}</Text>;
  };

  // Default translations
  const translations = {
    EN: {
      attendance: "ATTENDANCE",
      employeeInformation: "EMPLOYEE INFORMATION",
      attendanceInfo: "ATTENDANCE INFORMATION",
      fullName: "Full Name",
      address: "Address",
      phone: "Phone",
      email: "Email",
      printDate: "Print Date",
      dueSalary: "Due Salary",
      paidSalary: "Paid Salary",
      totalSalary: "Total Salary",
      presentDays: "Present Days",
      absentDays: "Absent Days",
      vacationDays: "Vacation Days",
      date: "Date",
      status: "Status",
      checkIn: "Check In",
      checkOut: "Check Out",
      salary: "Salary",
      alhabbarSlogan: "Alhabbar for Software Development",
      ehsiblySecondSlogan: "Ehsibly Software for Management and Accounting",
    },
    AR: {
      attendance: "كشف الحضور",
      employeeInformation: "معلومات الموظف",
      attendanceInfo: "معلومات كشف الحضور",
      fullName: "الاسم الكامل",
      address: "العنوان",
      phone: "الهاتف",
      email: "البريد الإلكتروني",
      printDate: "تاريخ الطباعة",
      dueSalary: "الراتب المستحق",
      paidSalary: "الراتب المدفوع",
      totalSalary: "الراتب الكلي",
      presentDays: "أيام الحضور",
      absentDays: "أيام الغياب",
      vacationDays: "أيام الإجازة",
      date: "التاريخ",
      status: "الحالة",
      checkIn: "وقت الدخول",
      checkOut: "وقت الخروج",
      salary: "الراتب",
      alhabbarSlogan: "شركة الحبّار للتطوير البرمجي",
      ehsiblySecondSlogan: "برنامج إحسبلي للإدارة والمحاسبة",
    },
  };

  const t = translations[language] || translations.EN;

  return (
    <Document>
      <Page size="A4" style={isArabic ? styles.pageArabic : styles.page}>
        {/* Header */}
        <View style={isArabic ? styles.headerRTL : styles.header}>
          <View style={styles.companyInfo}>
            <StyledText style={styles.companyName}>
              {defaultCompanyData.name}
            </StyledText>
            <StyledText
              style={
                isArabic
                  ? styles.companyDetailsRTL
                  : {
                      ...styles.companyDetails,
                      textAlign: "left",
                      direction: "ltr",
                    }
              }
            >
              {isArabic ? "العنوان: " : "Address: "}
              {defaultCompanyData.address}
            </StyledText>
            <StyledText style={styles.companyDetails}>
              {isArabic ? "هاتف: " : "Phone: "}
              {defaultCompanyData.phone}
            </StyledText>
            <StyledText style={styles.companyDetails}>
              {isArabic ? "بريد إلكتروني: " : "Email: "}
              {defaultCompanyData.email}
            </StyledText>
          </View>
          <StyledText style={styles.payslipTitle}>{t.attendance}</StyledText>
        </View>

        {/* Employee and Payslip Info */}
        <View style={isArabic ? styles.infoSectionRTL : styles.infoSection}>
          {/* Employee Information */}
          <View style={styles.infoBox}>
            <StyledText style={styles.sectionHeader}>
              {t.employeeInformation}
            </StyledText>

            <View style={isArabic ? styles.infoRowRTL : styles.infoRow}>
              <StyledText
                style={isArabic ? styles.infoLabelRTL : styles.infoLabel}
              >
                {t.fullName}:
              </StyledText>
              <StyledText>{defaultEmployeeData.fullName}</StyledText>
            </View>

            <View style={isArabic ? styles.infoRowRTL : styles.infoRow}>
              <StyledText
                style={isArabic ? styles.infoLabelRTL : styles.infoLabel}
              >
                {t.address}:
              </StyledText>
              <StyledText>{defaultEmployeeData.address}</StyledText>
            </View>

            <View style={isArabic ? styles.infoRowRTL : styles.infoRow}>
              <StyledText
                style={isArabic ? styles.infoLabelRTL : styles.infoLabel}
              >
                {t.phone}:
              </StyledText>
              <StyledText>{defaultEmployeeData.phone}</StyledText>
            </View>

            <View style={isArabic ? styles.infoRowRTL : styles.infoRow}>
              <StyledText
                style={isArabic ? styles.infoLabelRTL : styles.infoLabel}
              >
                {t.email}:
              </StyledText>
              <StyledText>{defaultEmployeeData.email}</StyledText>
            </View>
          </View>

          {/* Payslip Information */}
          <View style={styles.infoBox}>
            <StyledText style={styles.sectionHeader}>
              {t.attendanceInfo}
            </StyledText>
            <View style={styles.payslipInfoGrid}>
              <View style={isArabic ? styles.gridRowRTL : styles.gridRow}>
                <StyledText style={styles.gridHeader}>{t.printDate}</StyledText>
                <StyledText style={styles.gridValue}>
                  {console.log("PRINT DATE:", defaultAttendanceData.printDate)}
                  {defaultAttendanceData.printDate}
                </StyledText>
              </View>
              <View style={isArabic ? styles.gridRowRTL : styles.gridRow}>
                <StyledText style={styles.gridHeader}>
                  {t.totalSalary}
                </StyledText>
                <StyledText style={styles.gridValue}>
                  {defaultAttendanceData.totalSalary}
                </StyledText>
              </View>
              <View style={isArabic ? styles.gridRowRTL : styles.gridRow}>
                <StyledText style={styles.gridHeader}>{t.dueSalary}</StyledText>
                <StyledText style={styles.gridValue}>
                  {defaultAttendanceData.dueSalary}
                </StyledText>
              </View>
              <View style={isArabic ? styles.gridRowRTL : styles.gridRow}>
                <StyledText style={styles.gridHeader}>
                  {t.paidSalary}
                </StyledText>
                <StyledText style={styles.gridValue}>
                  {defaultAttendanceData.paidSalary}
                </StyledText>
              </View>
            </View>
          </View>
        </View>

        {/* Earnings Section */}
        <View style={styles.earningsSection}>
          {isArabic ? (
            <StyledText style={styles.sectionTitle}>
              يمثل هذا الجدول ايام الحضور والغياب لشهر{" "}
              <StyledText style={styles.boldText}>
                {console.log(
                  "MONTH:",
                  new Date(defaultAttendanceData.attendanceDate).getMonth()
                )}
                {new Date(defaultAttendanceData.attendanceDate).getMonth() + 1}
              </StyledText>{" "}
              سنة{" "}
              <StyledText style={styles.boldText}>
                {new Date(defaultAttendanceData.attendanceDate).getFullYear()}
              </StyledText>
            </StyledText>
          ) : (
            <StyledText style={styles.sectionTitle}>
              This table shows the attendance and absence for the month{" "}
              <StyledText style={styles.boldText}>
                {new Date(defaultAttendanceData.attendanceDate).getMonth() + 1}
              </StyledText>{" "}
              year{" "}
              <StyledText style={styles.boldText}>
                {new Date(defaultAttendanceData.attendanceDate).getFullYear()}
              </StyledText>
            </StyledText>
          )}

          <View style={styles.table}>
            <View style={isArabic ? styles.tableHeaderRTL : styles.tableHeader}>
              <StyledText style={styles.tableCell}>{t.date}</StyledText>
              <StyledText style={styles.tableCellCenter}>{t.status}</StyledText>
              <StyledText style={styles.tableCellRight}>{t.checkIn}</StyledText>
              <StyledText style={styles.tableCellRight}>
                {t.checkOut}
              </StyledText>
              <StyledText style={styles.tableCellRight}>{t.salary}</StyledText>
            </View>

            {days.map((day, index) => (
              <View
                style={isArabic ? styles.tableRowRTL : styles.tableRow}
                key={index}
              >
                <StyledText style={styles.tableCell}>{day.date}</StyledText>
                <StyledText style={styles.tableCellCenter}>
                  {day.status}
                </StyledText>
                <StyledText style={styles.tableCellRight}>
                  {day.checkIn}
                </StyledText>
                <StyledText style={styles.tableCellRight}>
                  {day.checkOut}
                </StyledText>
                <StyledText style={styles.tableCellRight}>
                  {day.salary}
                </StyledText>
              </View>
            ))}
          </View>

          {/* Attendance Info */}
          <View
            style={isArabic ? styles.attendanceInfoRTL : styles.attendanceInfo}
          >
            <StyledText>
              {t.presentDays}: {presentDays}
            </StyledText>
            <StyledText>
              {t.absentDays}: {absentDays}
            </StyledText>
            <StyledText>
              {t.vacationDays}: {vacationDays}
            </StyledText>
          </View>
        </View>

        <View
          fixed
          style={{
            position: "absolute",
            bottom: 20,
            left: 20,
            right: 20,
            textAlign: "center",
            paddingTop: 10,
            borderTopWidth: 1,
            borderTopColor: "#d1d5db",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Text
            style={{
              fontSize: 10,
              fontWeight: "bold",
              marginBottom: 4,
              fontFamily: "Tajawal",
            }}
          >
            {t.ehsiblySecondSlogan}
          </Text>
          <Text
            style={{
              fontSize: 8,
              fontFamily: "Tajawal",
            }}
          >
            {t.alhabbarSlogan}
          </Text>
        </View>
      </Page>
    </Document>
  );
};

export default MonthAttendancePDFTemplate;
